@if (!isDepthTool) {
  <div
    class="relative w-full h-full flex"
    [ngClass]="{
      'flex-col gap-3': width() <= 300,
      'flex-row gap-2 lg:flex-col lg:gap-3': width() > 300,
    }"
  >
    <div
      class="relative flex flex-col gap-2"
      [ngClass]="{
        'w-full h-auto  ': width() <= 300,
        'w-1/2 h-full justify-between lg:w-full lg:h-auto lg:justify-start': width() > 300,
      }"
    >
      <div
        class="relative w-full flex flex-col gap-2"
        [ngClass]="{
          ' h-auto  ': width() <= 300,
          'h-full lg:h-auto': width() > 300,
        }"
      >
        <input
          [(ngModel)]="stickerData.title"
          class="flex justify-center items-center text-center w-full px-2 py-0.5 text-sm lg:text-lg bg-slate-50 dark:bg-white text-gray-700 rounded-none"
          type="text"
        />
        <div
          class="relative w-full flex p-2 lg:p-4 justify-center items-center bg-black/10 dark:bg-white/20 rounded"
          [ngClass]="{ 'h-auto': width() <= 300, 'h-1/2 lg:h-auto': width() > 300 }"
        >
          <img
            class="max-h-[100%] object-contain object-center"
            [ngClass]="{ 'w-2/3': width() <= 300, 'w-full lg:w-2/3': width() > 300 }"
            [ngStyle]="{ aspectRatio: '1:0.65' }"
            [src]="stickerData.image"
            alt=""
          />
        </div>
        <div class="relative w-full flex flex-row rounded-full overflow-hidden">
          @for (cameraControl of cameraControlList; track cameraControl) {
            <button
              (click)="onClickCameraControl($index)"
              class="w-full flex px-1 py-0.5 text-[10px] lg:text-sm justify-center items-center"
              [ngClass]="{
                'bg-gray-200 dark:bg-gray-700 text-black dark:text-white':
                  cameraContolIndex !== $index,
                'bg-gray-700 dark:bg-white text-white dark:text-gray-700':
                  cameraContolIndex === $index,
              }"
            >
              {{ cameraControl }}
            </button>
          }
        </div>
      </div>
      <div class="w-full flex flex-row justify-between items-center">
        <div class="relative flex flex-row items-center gap-1 lg:gap-2">
          <p class="text-black dark:text-white text-sm lg:text-lg">Camera Center Lock</p>
          <div
            class="flex-none w-3 h-3 lg:w-4 lg:h-4 text-black/70 dark:text-white/70 hover:text-black/100 dark:hover:text-white/100"
            matTooltip="Locks the camera to the front of the car for a fixed front view. So you can focus on front-end design."
            aria-label="Button that displays a tooltip that can be programmatically disabled"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
              <path
                d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
              />
            </svg>
          </div>
        </div>
        <mat-slide-toggle
          [(ngModel)]="isCameraLocked"
          (ngModelChange)="onChangeCameraLocked()"
        ></mat-slide-toggle>
      </div>
      <div class="relative w-full flex flex-col">
        <p class="mb-1 text-white text-sm lg:text-lg">Scale</p>
        <div class="relative w-full flex flex-row justify-between mb-2">
          <button
            class="w-full flex justify-center items-center rounded-l-full bg-gray-700 text-white"
            (click)="changeScale(scale - 0.05)"
          >
            -
          </button>
          <input
            [(ngModel)]="scale"
            (ngModelChange)="changeScale()"
            min="0.1"
            max="10"
            class="flex justify-center items-center text-center w-full max-w-[40%] px-2 py-0.5 text-xs bg-slate-50 dark:bg-white text-gray-700 rounded-none"
            type="number"
          />
          <button
            class="w-full flex justify-center items-center rounded-r-full bg-gray-700 text-white"
            (click)="changeScale(scale + 0.05)"
          >
            +
          </button>
        </div>
        <p class="mb-1 text-white text-sm lg:text-lg">Rotation</p>
        <div class="relative w-full flex flex-row justify-between">
          <button
            class="w-full flex justify-center items-center rounded-l-full bg-gray-700 text-white"
            (click)="changeRotate(rotate - 5)"
          >
            -
          </button>
          <input
            [(ngModel)]="rotate"
            (ngModelChange)="changeRotate()"
            class="flex justify-center items-center text-center w-full max-w-[40%] px-2 py-0.5 text-xs bg-slate-50 dark:bg-white text-gray-700 rounded-none"
            min="0"
            max="360"
            type="number"
          />
          <button
            class="w-full flex justify-center items-center rounded-r-full bg-gray-700 text-white"
            (click)="changeRotate(rotate + 5)"
          >
            +
          </button>
        </div>
      </div>
    </div>
    <div
      class="relative flex flex-col gap-3 justify-between"
      [ngClass]="{ 'w-full ': width() <= 300, 'w-1/2 lg:w-full': width() > 300 }"
    >
      <div class="w-full flex flex-row justify-between items-center">
        <div class="relative flex flex-row items-center gap-1 lg:gap-2">
          <p class="text-black dark:text-white text-sm lg:text-lg">Dual Side</p>
          <div
            class="flex-none w-3 h-3 lg:w-4 lg:h-4 text-black/70 dark:text-white/70 hover:text-black/100 dark:hover:text-white/100"
            matTooltip="Mirror sticker to the other side of the car."
            aria-label="Button that displays a tooltip that can be programmatically disabled"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor">
              <path
                d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
              />
            </svg>
          </div>
        </div>
        <mat-slide-toggle [(ngModel)]="dualsideOption"></mat-slide-toggle>
      </div>
      <div class="relative w-full flex flex-col gap-2 lg:flex-row">
        <button
          class="w-full px-2 py-1 bg-red-600 text-white rounded text-xs lg:text-base"
          (click)="onClickCancel()"
        >
          Cancel
        </button>
        <button
          class="w-full px-2 py-1 bg-gray-700 text-white rounded text-xs lg:text-base"
          (click)="onClickAttach()"
        >
          Attach
        </button>
      </div>
    </div>
  </div>
} @else {
  <div
    class="relative w-full h-full flex"
    [ngClass]="{
      'flex-col gap-3': width() <= 300,
      'flex-row gap-2 lg:flex-col lg:gap-3': width() > 300,
    }"
  >
    <div
      class="relative flex flex-col gap-2"
      [ngClass]="{
        'w-full h-auto  ': width() <= 300,
        'w-1/2 h-full justify-between lg:w-full lg:h-auto lg:justify-start': width() > 300,
      }"
    >
      <p class="mb-1 text-white text-sm lg:text-lg">Depth</p>
      <div class="relative w-full flex flex-row justify-between">
        <button
          class="w-full flex justify-center items-center rounded-l-full bg-gray-700 text-white"
          (click)="changeDepth(depth - 0.1)"
        >
          -
        </button>
        <input
          [(ngModel)]="depth"
          (ngModelChange)="changeDepth(depth)"
          class="flex justify-center items-center text-center w-full max-w-[40%] px-2 py-0.5 text-xs bg-slate-50 dark:bg-white text-gray-700 rounded-none"
          min="0"
          max="10"
          type="number"
        />
        <button
          class="w-full flex justify-center items-center rounded-r-full bg-gray-700 text-white"
          (click)="changeDepth(depth + 0.1)"
        >
          +
        </button>
      </div>
    </div>
    <button
      class="w-full px-2 py-1 bg-gray-700 text-white rounded text-xs lg:text-base"
      (click)="onClickCancel()"
    >
      Complete
    </button>
  </div>
}
